import { Component, OnInit, ChangeDetectionStrategy, input, inject, signal } from '@angular/core';
import { DataService, GetPageDataQuery } from '@ng-chronicles/shared/data-access';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, RouterModule]
})
export class HeaderComponent implements OnInit {
  readonly site = input<any>(undefined);

  data$: Observable<GetPageDataQuery['pagesSetup'] | undefined>;
  showNav = signal(false);

  private readonly _dataService = inject(DataService);

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.data$ = this._dataService.getPageData().pipe(
      map((result: any) => (result.data as GetPageDataQuery | undefined)?.pagesSetup as GetPageDataQuery['pagesSetup'] | undefined),
      catchError((err) => {
        // Log and recover so header doesn't crash the app when the live query
        // unexpectedly fails or returns an unexpected shape.
        // eslint-disable-next-line no-console
        console.warn('Header getData failed, falling back to undefined', err);
        return of(undefined);
      })
    );
  }

  onResize(event): void{
    if (event.target.innerWidth < 1024)  {
      this.showNav.set(false);
    }
  }

  toggleNav(): void {
    this.showNav.update(v => !v);
  }

  closeNav(): void {
    this.showNav.set(false);
  }
}
